<template>
  <div class="peopleindex">
    <div class="toolAndFilter">
      <div class="tool">
        <div style="display: inline-block;margin-right: 30px;">
          <el-button
            v-if="role.includes('add')"
            style="border-radius: 4px"
            size="medium"
            type="good"
            icon="el-icon-folder"
            @click="tianjiaHandler"
          >新建会议
          </el-button>
        </div>
      </div>
      <div class="filter">
        <div style="display: inline-block;max-width: 400px;flex-basis: 400px">
          <el-input
            v-model="query.name"
            size="medium"
            placeholder="输入关键词查询"
            clearable
            @clear="sreachTableData"
            @keyup.native.13="sreachTableData"
          >
            <el-button
              slot="append"
              size="medium"
              type="good"
              icon="el-icon-search"
              @click="sreachTableData"
            >查询</el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="body">
      <el-table
        :data="peopleTableData"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          show-overflow-tooltip
          type="index"
          label="#"
          width="50"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name"
          label="会议名称"
          min-width="120"
        >
          <template slot-scope="scope">
            <div
              class="columnStyle"
              @click="detailHandler(scope.row,role.includes('see'))"
            >
              <img
                src="@/assets/image/fileicon/file.png"
                alt=""
              >
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          prop="papersNum"
          label="文件数"
          width="120"
        >
        </el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          label="操作"
          width="240"
        >
          <template slot-scope="scope">
            <div style="display: flex;justify-content: flex-end">
              <el-button
                v-if="role.includes('see')"
                size="mini"
                plain
                type="success"
                icon="el-icon-view"
                @click="detailHandler(scope.row)"
              >查看
              </el-button>
              <el-button
                v-if="role.includes('edit')"
                size="mini"
                plain
                type="primary"
                icon="el-icon-edit-outline"
                @click="XiuGaiHandler(scope.row)"
              >编辑
              </el-button>
              <el-button
                v-if="role.includes('del')"
                size="mini"
                plain
                type="danger"
                icon="el-icon-delete"
                @click="handlerRemoveClick(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="tablePagination">
      <el-pagination
        background
        :current-page="query.pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="query.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="query.totalRecord"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      class="addDialog"
      :title="formDialog.edit?'编辑会议':'新建会议'"
      :visible.sync="formDialog.formVisible"
      @close="cancelForm('form')"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="140px"
        size="small"
      >
        <div class="info">
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item
                label="会议名称"
                prop="name"
              >
                <el-input
                  v-model="form.name"
                  placeholder="请输入会议名称"
                  onblur="this.value=this.value.replace(/\ +/g, '')"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="会议议题"
                prop="name"
              >
                <el-input
                  v-model="form.topics"
                  type="textarea"
                  :autosize="{ minRows: 5, maxRows: 100000}"
                  resize="none"
                  placeholder="请输入会议名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="formDialog.formVisible=false">取消</el-button>
        <el-button
          type="good"
          @click="submitForm('form')"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  page,
  create,
  update,
  deleteById
} from '@/api/meet/index'
// import {
//   getAreaTree
// } from '@/api/sys'
// import UploadImg from "./UploadImg";
import {
  Button,
  Input,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Form,
  FormItem,
  Row, Message,
  Col,
  MessageBox
} from 'element-ui';
import storage from 'store'
export default {
  name: "FileTable",
  components: {
    // UploadImg,
    [Button.name]: Button,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Row.name]: Row,
    [Col.name]: Col,
    [Dialog.name]: Dialog
  },
  data () {
    return {
      peopleTableData: [],
      adminFlag: false,
      role: {},
      currentTab:"",
      query: {
        pageNum: 1,
        pageSize: 10,
        totalRecord: 0,
        name: "",
        type: '1',
      },
      form: {
        'id': '',
        "name": "",
        "topics": '',
      },
      rules: {
        name: [{
          required: true,
          message: '请输入会议名称',
          trigger: 'blur'
        },
        {
          max: 100,
          message: '长度在 100 个字符内',
          trigger: 'blur'
        }
        ],
        topics: [{
          required: true,
          message: '请输入会议议题',
          trigger: 'blur'
        },
        {
          max: 10000,
          message: '长度在 10000 个字符内',
          trigger: 'blur'
        }
        ],
      },
      cascaderProps: {
        value: 'id',
        label: 'text'
      },
      cascaderPropsOne: {
        value: 'id',
        label: 'text',
        checkStrictly: true
      },
      areaTreehu: [],
      areaTreeJu: [],
      formDialog: {
        loading: false,
        edit: false,
        peopleOption: [],
        formVisible: false
      },
      roles:{}
    }
  },
  created () {
    this.roles = storage.get('role');
    let t = this.$route.name;
    this.currentTab=t.toLowerCase()
    this.role = this.roles[this.currentTab];
    let type = 0;
    if (t === 'CW') {
      type = 1;
    } else if (t == 'DB') {
      type = 2;
    } else if (t == 'ZR') {
      type = 3;
    } else if (t == 'QT') {
      type = 4;
    }else if (t == 'SYYJK') {
      type = 5;
    }
    this.query.type = type;
    this.getList();
  },
  methods: {
    detailHandler (data, show = true) {
      if (!show) {
        return
      }
      this.$router.push({
        name: this.roles[`${this.currentTab}m`][0].toUpperCase(), params: { id: data.id,tab:this.currentTab }, query: { name: data.name }
      })
    },
    handlerRemoveClick (data) {
      let that = this;
      MessageBox.confirm('此操作将永久删除该会议及相关文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteById(
          data.id
        ).then(res => {
          if (res.status == 1) {
            Message.success('删除成功');
            that.sreachTableData();
          }
        })
      })

    },
    submitForm (formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.form.type = that.query.type;
          if (that.formDialog.edit) {
            update(that.form).then(res => {
              if (res.status == 1) {
                Message.success('修改成功');
                that.getList();
                that.formDialog.formVisible = false;
              }
            })
          } else {
            that.form.beadhouseId = this.id;
            create(that.form).then(res => {
              if (res.status == 1) {
                Message.success('添加成功');
                that.formDialog.formVisible = false;
                that.sreachTableData();
              }
            })
          }
        }
      });
    },
    areaCodesChangeHandler (f, val) {
      if (val) {
        this.form[f] = val[val.length - 1];
      }
    },
    cancelForm (formName) {
      this.formDialog.peopleOption = [];
      this.$refs[formName].resetFields();
    },
    /**
     * 从业人员添加
     */
    tianjiaHandler () {
      this.formDialog.formVisible = true;
      this.form.id = '';
      this.formDialog.edit = false;
    },
    XiuGaiHandler (data) {
      let that = this;
      that.formDialog.formVisible = true;
      that.form.id = data.id;
      that.form.name = data.name;
      that.form.topics = data.topics;
      that.formDialog.edit = true;
    },
    getList () {
      let that = this;
      let f = JSON.parse(JSON.stringify(that.query));
      page(f).then(res => {
        if (res.status == 1) {
          that.peopleTableData = res.rows;
          that.query.totalRecord = res.total
        }
      })
    },
    sreachTableData () {
      this.query.pageNum = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.query.pageNum = val;
      this.getList();
    },
    handleSizeChange (val) {
      this.query.pageSize = val;
      this.handleCurrentChange(1);
    }
  }
}
</script>

<style scoped>
div {
  word-break: break-all;
}

.peopleindex {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.el-scrollbar ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.peopleindex .body {
  height: 0;
  flex-grow: 1;
}

.peoples {
  display: flex;
  flex-wrap: wrap;
}

.peoples .people {
  width: 390px;
  background-color: rgba(255, 255, 255, 100);
  color: rgba(16, 16, 16, 100);
  font-family: Roboto;
  border: 1px solid rgba(230, 230, 230, 100);
  padding: 16px;
  display: flex;
  color: rgba(16, 16, 16, 100);
  font-size: 14px;
  font-family: SourceHanSansSC-regular;
  line-height: 1.77em;
  margin: 0 16px 16px 0;
  flex-shrink: 0;
}

.peoples .people .headImg {
  width: 120px;
  height: 170px;
  position: relative;
  flex-shrink: 0;
  margin-right: 20px;
}

.peoples .people .headImg .tip {
  position: absolute;
  width: 100%;
  height: 24px;
  line-height: 24px;
  background-color: rgba(46, 136, 242, 100);
  text-align: center;
  bottom: 0;
  left: 0;
  color: rgba(255, 255, 255, 100);
  font-size: 14px;
  font-family: SourceHanSansSC-bold;
  font-weight: bold;
}

.people .tit {
  color: rgba(16, 16, 16, 100);
  font-size: 18px;
  font-family: SourceHanSansSC-bold;
  font-weight: bold;
}

.toolAndFilter {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
}

.toolAndFilter .tool {
  display: flex;
  width: 410px;
  flex-shrink: 0;
  align-items: center;
}

.toolAndFilter .filter {
  justify-content: flex-end;
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.tablePagination {
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.el-button {
  border-radius: 4px;
}

.el-form >>> .el-input__inner {
  border-radius: 4px;
}

.addDialog.el-dialog__wrapper >>> .el-dialog__body {
  display: block;
  overflow: auto;
  flex-grow: initial;
  flex-shrink: initial;
  flex-basis: initial;
}

.el-table .el-button + .el-button {
  margin-left: 10px;
  position: relative;
}

/* .el-table .el-button + .el-button::before {
  content: '';
  display: block;
  width: 0;
  height: 14px;
  border-right: 1px solid #999;
  position: absolute;
  left: -9px;
  top: 50%;
  transform: translateY(-50%);
} */

.el-table .el-button.delect {
  color: #ff5342;
}
.astyle {
  color: #606266;
}
.astyle:hover {
  text-decoration: underline;
}
.columnStyle {
  /* font-size: 16px; */
  padding-left: 30px;
  position: relative;
  cursor: pointer;
}
.columnStyle img {
  width: 20px;
  height: 18px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>